import { render, staticRenderFns } from "./task_messaging_share.vue?vue&type=template&id=2e6c39f2&scoped=true"
import script from "./task_messaging_share.vue?vue&type=script&lang=js"
export * from "./task_messaging_share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c39f2",
  null
  
)

export default component.exports